import { Reaction, ReactionType } from '../model/reactions';

export const parseReactionsCSV = (csvContent: string): Reaction[] => {
  const lines = csvContent
    .trim()
    .split('\n')
    .filter((line) => line.trim());

  // Пропускаем заголовок
  const dataLines = lines.slice(1);

  const reactions: Reaction[] = [];
  let currentType: ReactionType | undefined;

  // Категории для идентификации типов
  const categoryKeywords: Record<string, ReactionType> = {
    skinReactions: 'skinReactions',
    localReactions: 'localReactions',
    generalReactions: 'generalReactions',
    allergicReactions: 'allergicReactions',
    respiratoryReactions: 'respiratoryReactions',
    cardiovascularReactions: 'cardiovascularReactions',
  };

  dataLines.forEach((line) => {
    const [code, ru, en] = line.split(',').map((item) => item.trim());

    if (!code || !ru || !en) return;

    // Проверяем, является ли это категорией
    const isCategory = Object.keys(categoryKeywords).includes(code);

    if (isCategory) {
      currentType = categoryKeywords[code];
      reactions.push({
        code,
        ru,
        en,
        type: currentType,
        isCategory: true,
      });
    } else {
      reactions.push({
        code,
        ru,
        en,
        type: currentType,
        isCategory: false,
      });
    }
  });

  return reactions;
};
